export default {
  props: {
    show: Boolean,
    value: Boolean,
  },

  computed: {
    visible: {
      set(v) {
        this.$emit("changeShow", v);
        this.$emit("input", v);
      },
      get() {
        return this.show || this.value;
      },
    },
  },

  methods: {
    close() {
      this.visible = false;
    },
  },
};
